import React from 'react';
import If from '../operator/if';

export default props => (
	<form role='form' onSubmit={props.event}>
		{props.children}
	</form>
);
